import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Competence} from 'APIs/letrusAPI/studentAnnualReport/types';
import styles from './CompetenceCard.module.scss';

function CompetenceCard({status, points, label, nickname}: Competence) {
  return (
    <article
      className={`${styles.container} ${styles[status]}`}
      aria-label="Informações da competência"
    >
      <section className={styles.cardHeader}>
        <header>
          <FontAwesomeIcon
            size="lg"
            color={status === 'positive' ? '#00c341' : '#e94b56'}
            icon={status === 'positive' ? 'medal' : 'circle-exclamation'}
          />
          <span className={styles.badge}>{label}</span>
          <h4 className={styles.competenceTitle}>{nickname}</h4>
        </header>

        <p className={styles.competenceNote}>
          {status === 'positive' ? 'Competência em destaque' : 'Requer atenção'}
        </p>
      </section>

      <p className={styles.points}>
        <strong>{points}</strong> <span>pontos</span>
      </p>
    </article>
  );
}

export default CompetenceCard;
